/* @jsx h */
import { defineComponent, h } from "vue";
import { ServiceMethodRequirement } from "@lemmonhq/types";

export type ServiceMethodRequirementEditorProps = {
  value: ServiceMethodRequirement;
  onChange: (requirement: ServiceMethodRequirement) => void;
};

export const ServiceMethodRequirementEditor =
  defineComponent<ServiceMethodRequirementEditorProps>({
    name: "ServiceMethodRequirementEditor",
    props: ["value", "onChange"],
    setup(props) {
      const updateField = (
        field: keyof ServiceMethodRequirement,
        value: any,
      ) => {
        props.onChange({
          ...props.value,
          [field]: value,
        });
      };

      const serviceOptions = [
        {
          value: "takeaway",
          label: "Takeaway",
          icon: "🥡",
          description: "Order for pickup",
        },
        {
          value: "dine-in",
          label: "Dine In",
          icon: "🍽️",
          description: "Eat at restaurant",
        },
        {
          value: "delivery",
          label: "Delivery",
          icon: "🚚",
          description: "Delivered to customer",
        },
      ];

      return () => (
        <div class="card border">
          <div class="card-body p-4">
            <h4 class="card-title text-accent text-lg flex items-center gap-2">
              <div class="w-2 h-2 bg-accent rounded-full"></div>
              Service Method Requirement
            </h4>

            <div class="mt-4">
              <label class="label">
                <span class="label-text font-medium">
                  Required Service Method
                </span>
              </label>

              <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-2">
                {serviceOptions.map((option) => (
                  <label
                    key={option.value}
                    class={`
                    label cursor-pointer p-4 rounded-lg border-2 transition-all hover:scale-105
                    ${
                      props.value.value === option.value
                        ? "border-primary bg-primary/10 shadow-lg"
                        : "border-base-300"
                    }
                  `}
                  >
                    <div class="flex flex-col items-center space-y-2 w-full">
                      <div class="text-2xl">{option.icon}</div>
                      <input
                        type="radio"
                        name="serviceMethod"
                        value={option.value}
                        checked={props.value.value === option.value}
                        onChange={(e) =>
                          updateField(
                            "value",
                            (e.target as HTMLInputElement).value,
                          )
                        }
                        class="radio radio-primary radio-sm"
                      />
                      <div class="text-center">
                        <div class="font-medium">{option.label}</div>
                        <div class="text-xs text-base-content/70">
                          {option.description}
                        </div>
                      </div>
                    </div>
                  </label>
                ))}
              </div>

              <label class="label">
                <span class="label-text-alt">
                  Promotion will only apply to {props.value.value || "selected"}{" "}
                  orders
                </span>
              </label>
            </div>
          </div>
        </div>
      );
    },
  });
